// // PartnerFormStep6.tsx
// import React, { useEffect, useState } from "react";
// import { usePartnerFormStore } from "../store/usePartnerFormStore";
// import { Button, NavigationButtons } from "./ui";
// import {
//   createPaymentOrder,
//   uploadDocuments,
//   submitPartnerForm,
//   verifyPayment,
//   checkHexConflicts,
// } from "../apis/partnerForm";
// import { initializeRazorpayCheckout } from "../services/razorpayService";
// import { calculatePayment } from "../utils/calculatePayment";

// const PartnerFormStep6: React.FC = () => {
//   const {
//     listingDetails,
//     basicInfo,
//     serviceDetails,
//     coverageAreas,
//     additionalInfo,
//     payment,
//     documents,
//     setUploadedDocumentUrls,
//     previousStep,
//     isCreatingOrder,
//     setIsCreatingOrder,
//     setIsSubmitting,
//     setPaymentOrder,
//     updatePayment,
//     setSubmittedFormId,
//     updateListingDetails,
//     errors,
//     setError,
//   } = usePartnerFormStore();

//   const currentService = serviceDetails.services;
//   const [paymentInitiated, setPaymentInitiated] = useState(false);

//   useEffect(() => {
//     // Update payment amount when listing details change
//     if (listingDetails.listingAmount > 0) {
//       updatePayment({
//         amount: listingDetails.listingAmount,
//         currency: "INR",
//       });
//     }
//   }, [listingDetails.listingAmount, updatePayment]);

//   // Ensure listing amount reflects the coverage plan price
//   useEffect(() => {
//     if (coverageAreas.selectedPlan) {
//       const amount = calculatePayment({
//         selectedPlan: coverageAreas.selectedPlan,
//         selectedHexagons: coverageAreas.selectedHexagons,
//       });
//       if (amount !== listingDetails.listingAmount) {
//         updateListingDetails({ listingAmount: amount, totalServiceCharge: amount });
//       }
//     }
//   }, [coverageAreas, listingDetails.listingAmount, updateListingDetails]);

//   const handleCreatePaymentOrder = async () => {
//     try {
//       setIsCreatingOrder(true);

//       // Pre-payment hexagon conflict check - get all subcategories
//       const allSubcategories = currentService?.subcategories ?? [];
//       const selectedHexagons = coverageAreas.selectedHexagons ?? [];

//       if (allSubcategories.length > 0 && selectedHexagons.length > 0) {
//         const conflictResult = await checkHexConflicts(allSubcategories, selectedHexagons);
//         if (conflictResult.unavailableHexagons?.length > 0) {
//           setError(
//             "submission",
//             "Some selected areas are already taken by another partner in your category. Please go back to the coverage step and choose different areas on the map."
//           );
//           setIsCreatingOrder(false);
//           return;
//         }
//       }

//       const order = await createPaymentOrder(
//         listingDetails.listingAmount,
//         "INR"
//       );
//       setPaymentOrder(order);
//       setPaymentInitiated(true);

//       // Initialize Razorpay checkout
//       await initializeRazorpayCheckout(
//         order,
//         {
//           onSuccess: async (response) => {
//             try {
//               // Verify payment
//               await verifyPayment(
//                 response.razorpay_order_id,
//                 response.razorpay_payment_id,
//                 response.razorpay_signature
//               );

//               // Prepare payment data
//               const paymentData = {
//                 razorpayOrderId: response.razorpay_order_id,
//                 razorpayPaymentId: response.razorpay_payment_id,
//                 razorpaySignature: response.razorpay_signature,
//                 amount: listingDetails.listingAmount,
//                 currency: "INR",
//               };

//               // Update payment details in store
//               updatePayment(paymentData);

//               // Submit form after payment with the payment data
//               await handleSubmitForm(paymentData);
//             } catch (error) {
//               console.error("Payment verification error:", error);
//               setError(
//                 "payment",
//                 "Payment verification failed. Please contact support."
//               );
//             }
//           },
//           onError: (error) => {
//             console.error("Payment error:", error);
//             setError("payment", error);
//             setIsCreatingOrder(false);
//             setPaymentInitiated(false);
//           },
//           onDismiss: () => {
//             setIsCreatingOrder(false);
//             setPaymentInitiated(false);
//           },
//         },
//         {
//           name: basicInfo.businessName,
//           description: "Partner Registration Payment",
//           contact: basicInfo.mobileNumber,
//         }
//       );
//     } catch (error) {
//       console.error("Error creating payment order:", error);
//       setError("payment", "Failed to create payment order. Please try again.");
//       setIsCreatingOrder(false);
//     }
//   };

//   const handleSubmitForm = async (paymentData?: {
//     razorpayOrderId: string;
//     razorpayPaymentId: string;
//     razorpaySignature: string;
//     amount: number;
//     currency?: string;
//   }) => {
//     try {
//       setIsSubmitting(true);

//       // Use provided payment data or fall back to store payment
//       const finalPayment = paymentData || payment;

//       // Validate payment is complete
//       if (
//         !finalPayment.razorpayOrderId ||
//         !finalPayment.razorpayPaymentId ||
//         !finalPayment.razorpaySignature
//       ) {
//         setError(
//           "submission",
//           "Payment information is incomplete. Please complete the payment first."
//         );
//         setIsSubmitting(false);
//         return;
//       }

//       // Pre-submission hexagon conflict check - get all subcategories
//       const allSubcategories = currentService?.subcategories ?? [];
//       const selectedHexagons = coverageAreas.selectedHexagons ?? [];

//       if (allSubcategories.length > 0 && selectedHexagons.length > 0) {
//         const conflictResult = await checkHexConflicts(allSubcategories, selectedHexagons);
//         if (conflictResult.unavailableHexagons?.length > 0) {
//           setError(
//             "submission",
//             "Some selected areas are already taken by another partner in your category. Please go back and choose different areas on the map."
//           );
//           setIsSubmitting(false);
//           return;
//         }
//       }

//       // Upload documents if any
//       let documentUrls: string[] = [];
//       if (documents.length > 0) {
//         documentUrls = await uploadDocuments(documents);
//         setUploadedDocumentUrls(documentUrls);
//       }

//       // Prepare service details in the format expected by backend (single object, not array)
//       const formattedServiceDetails = {
//         services: {
//           category: currentService.category,
//           subcategories: currentService.subcategories,
//           serviceChargeCategory: currentService.serviceChargeCategory,
//         }
//       };

//       const formData = {
//         basicInfo,
//         serviceDetails: formattedServiceDetails,
//         coverageAreas: {
//           selectedPlan: coverageAreas.selectedPlan,
//           selectedHexagons: coverageAreas.selectedHexagons,
//         },
//         additionalInfo,
//         listingDetails,
//         payment: {
//           razorpayOrderId: finalPayment.razorpayOrderId,
//           razorpayPaymentId: finalPayment.razorpayPaymentId,
//           razorpaySignature: finalPayment.razorpaySignature,
//           amount: finalPayment.amount || listingDetails.listingAmount,
//           currency: finalPayment.currency || "INR",
//         },
//         documents: documentUrls,
//       };

//       const result = await submitPartnerForm(formData);
//       setSubmittedFormId(result._id || result.id);
//     } catch (error: any) {
//       console.error("Error submitting form:", error);
//       // Show specific validation errors if available
//       const errorMessage =
//         error.errors && error.errors.length > 0
//           ? error.errors.join(", ")
//           : error.message || "Failed to submit form. Please try again.";
//       setError("submission", errorMessage);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="space-y-5 md:space-y-6">
//       <div>
//         <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
//           Payment & Completion
//         </h2>
//         <p className="text-sm md:text-base text-secondary-600">
//           Complete payment and upload required documents
//         </p>
//       </div>

//       {/* Payment Section */}
//       <div className="space-y-4">
//         <div className="p-5 md:p-6 bg-gradient-to-br from-primary-50 to-secondary-50 rounded-xl border-2 border-primary-200">
//           <div className="flex justify-between items-center">
//             <div>
//               <p className="text-sm font-medium text-secondary-700 mb-1">
//                 Listing Amount
//               </p>
//               <p className="text-3xl md:text-4xl font-bold text-primary-600">
//                 ₹{listingDetails.listingAmount.toLocaleString()}
//               </p>
//               {coverageAreas.selectedPlan && (
//                 <p className="text-xs text-secondary-500 mt-1">
//                   {coverageAreas.selectedPlan.planName} Plan •{" "}
//                   {coverageAreas.selectedHexagons.length} hexagons •{" "}
//                   ~{(coverageAreas.selectedHexagons.length * 5.16).toFixed(0)} km²
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>

//         {!paymentInitiated ? (
//           <Button
//             onClick={handleCreatePaymentOrder}
//             size="lg"
//             fullWidth
//             isLoading={isCreatingOrder}
//             className="min-h-[56px] md:min-h-[48px]"
//           >
//             Proceed to Payment
//           </Button>
//         ) : (
//           <div className="text-center p-4 bg-blue-50 rounded-lg border border-blue-200">
//             <p className="text-sm md:text-base text-blue-700">
//               Payment window opened. Please complete the payment.
//             </p>
//           </div>
//         )}
//       </div>

//       {errors.payment && (
//         <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
//           <p className="text-sm md:text-base text-red-600">
//             {errors.payment as string}
//           </p>
//         </div>
//       )}

//       {errors.submission && (
//         <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
//           <p className="text-sm md:text-base text-red-600">
//             {errors.submission as string}
//           </p>
//         </div>
//       )}

//       <NavigationButtons
//         onPrevious={previousStep}
//         onNext={() => {}}
//         showNext={false}
//         previousDisabled={paymentInitiated}
//       />
//     </div>
//   );
// };

// export default PartnerFormStep6;

import React, { useEffect, useState } from "react";
import { usePartnerFormStore } from "../store/usePartnerFormStore";
import { Button, NavigationButtons } from "./ui";
import {
  createPaymentOrder,
  uploadDocuments,
  submitPartnerForm,
  verifyPayment,
  checkHexConflicts,
} from "../apis/partnerForm";
import { initializeRazorpayCheckout } from "../services/razorpayService";
import { calculatePayment } from "../utils/calculatePayment";
import { BranchDetails } from "../store/types";

const PartnerFormStep6: React.FC = () => {
  const {
    listingDetails,
    basicInfo,
    serviceDetails,
    coverageAreas,
    branchDetails,
    additionalInfo,
    payment,
    documents,
    setUploadedDocumentUrls,
    previousStep,
    isCreatingOrder,
    setIsCreatingOrder,
    setIsSubmitting,
    setPaymentOrder,
    updatePayment,
    setSubmittedFormId,
    submittedFormId,
    updateListingDetails,
    errors,
    setError,
    isSubmitting,
  } = usePartnerFormStore();

  const currentService = serviceDetails.services;
  const selectedPlan = coverageAreas.selectedPlan;
  const isTrial = selectedPlan?.isTrial === "yes";
  const [paymentInitiated, setPaymentInitiated] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const pricing = selectedPlan?.pricing;
  const payInitially = pricing?.payInitially ?? 0;
  const trialSellingPrice = payInitially > 0 ? payInitially : (pricing?.sellingPrice || 0);
  
  const trialCgst = Math.round(trialSellingPrice * 0.09);
  const trialSgst = Math.round(trialSellingPrice * 0.09);
  const trialFinalAmount = trialSellingPrice + trialCgst + trialSgst;

  useEffect(() => {
    // Update payment amount when listing details change
    if (listingDetails.listingAmount > 0) {
      updatePayment({
        amount: listingDetails.listingAmount,
        currency: "INR",
      });
    }
  }, [listingDetails.listingAmount, updatePayment]);

  // Ensure listing amount reflects the coverage plan price
  useEffect(() => {
    if (selectedPlan) {
      const amount = calculatePayment({
        selectedPlan: selectedPlan,
        selectedHexagons: coverageAreas.selectedHexagons,
      });
      if (amount !== listingDetails.listingAmount) {
        updateListingDetails({ listingAmount: amount, totalServiceCharge: amount });
      }
    }
  }, [coverageAreas, listingDetails.listingAmount, updateListingDetails, selectedPlan]);

  const handleCreatePaymentOrder = async () => {
    try {
      if (!termsAccepted) {
        setError("submission", "You must accept the Terms and Conditions to register");
        return;
      }

      setIsCreatingOrder(true);

      // Pre-payment hexagon conflict check (only if we have hexagons)
      const allSubcategories = currentService?.subcategories ?? [];
      const selectedHexagons = coverageAreas.selectedHexagons ?? [];

      if (allSubcategories.length > 0 && selectedHexagons.length > 0) {
        const conflictResult = await checkHexConflicts(
          allSubcategories,
          selectedHexagons,
          currentService?.category,
          submittedFormId
        );
        if (conflictResult.unavailableHexagons?.length > 0) {
          setError(
            "submission",
            "Some selected areas are already taken by another partner in your category. Please go back to the coverage step and choose different areas on the map."
          );
          setIsCreatingOrder(false);
          return;
        }
      }

      // Prepare metadata with branch info
      const metadata = {
        branchName: branchDetails?.branchName,
        branchType: branchDetails?.branchType,
        businessName: basicInfo.businessName,
      };

      // For trial plans, create payment order with trial amount
      if (isTrial && trialFinalAmount > 0) {
        const order = await createPaymentOrder(Math.round(trialFinalAmount), "INR", metadata);
        setPaymentOrder(order);
        setPaymentInitiated(true);

        // Initialize Razorpay checkout for trial payment
        await initializeRazorpayCheckout(
          order,
          {
            onSuccess: async (response) => {
              try {
                await verifyPayment(
                  response.razorpay_order_id,
                  response.razorpay_payment_id,
                  response.razorpay_signature
                );

                const paymentData = {
                  razorpayOrderId: response.razorpay_order_id,
                  razorpayPaymentId: response.razorpay_payment_id,
                  razorpaySignature: response.razorpay_signature,
                  amount: Math.round(trialFinalAmount),
                  currency: "INR",
                };

                updatePayment(paymentData);
                await handleSubmitForm(paymentData);
              } catch (error) {
                console.error("Payment verification error:", error);
                setError(
                  "payment",
                  "Payment verification failed. Please contact support."
                );
              }
            },
            onError: (error) => {
              console.error("Payment error:", error);
              setError("payment", error);
              setIsCreatingOrder(false);
              setPaymentInitiated(false);
            },
            onDismiss: () => {
              setIsCreatingOrder(false);
              setPaymentInitiated(false);
            },
          },
          {
            name: basicInfo.businessName,
            description: "Partner Registration - Trial Plan",
            contact: basicInfo.mobileNumber,
          }
        );
        return;
      }

      // Regular paid plan
      const order = await createPaymentOrder(
        listingDetails.listingAmount,
        "INR",
        metadata
      );
      setPaymentOrder(order);
      setPaymentInitiated(true);

      // Initialize Razorpay checkout
      await initializeRazorpayCheckout(
        order,
        {
          onSuccess: async (response) => {
            try {
              await verifyPayment(
                response.razorpay_order_id,
                response.razorpay_payment_id,
                response.razorpay_signature
              );

              const paymentData = {
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpaySignature: response.razorpay_signature,
                amount: listingDetails.listingAmount,
                currency: "INR",
              };

              updatePayment(paymentData);
              await handleSubmitForm(paymentData);
            } catch (error) {
              console.error("Payment verification error:", error);
              setError(
                "payment",
                "Payment verification failed. Please contact support."
              );
            }
          },
          onError: (error) => {
            console.error("Payment error:", error);
            setError("payment", error);
            setIsCreatingOrder(false);
            setPaymentInitiated(false);
          },
          onDismiss: () => {
            setIsCreatingOrder(false);
            setPaymentInitiated(false);
          },
        },
        {
          name: basicInfo.businessName,
          description: "Partner Registration Payment",
          contact: basicInfo.mobileNumber,
        }
      );
    } catch (error) {
      console.error("Error creating payment order:", error);
      setError("payment", "Failed to create payment order. Please try again.");
      setIsCreatingOrder(false);
    }
  };

const handleSubmitForm = async (paymentData?: {
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
  amount: number;
  currency?: string;
}) => {
  try {
    if (!termsAccepted) {
      setError("submission", "You must accept the Terms and Conditions to register");
      return;
    }

    setIsSubmitting(true);

    // Prepare payment data with guaranteed string values
    let finalRazorpayOrderId: string;
    let finalRazorpayPaymentId: string;
    let finalRazorpaySignature: string;
    let finalAmount: number;
    let finalCurrency: string;

    if (paymentData) {
      finalRazorpayOrderId = paymentData.razorpayOrderId;
      finalRazorpayPaymentId = paymentData.razorpayPaymentId;
      finalRazorpaySignature = paymentData.razorpaySignature;
      finalAmount = paymentData.amount;
      finalCurrency = paymentData.currency || "INR";
    } else if (payment.razorpayOrderId && payment.razorpayPaymentId && payment.razorpaySignature) {
      finalRazorpayOrderId = payment.razorpayOrderId;
      finalRazorpayPaymentId = payment.razorpayPaymentId;
      finalRazorpaySignature = payment.razorpaySignature;
      finalAmount = payment.amount;
      finalCurrency = payment.currency || "INR";
    } else {
      setError(
        "submission",
        "Payment information is incomplete. Please complete the payment first."
      );
      setIsSubmitting(false);
      return;
    }

    // Validate payment
    if (!finalRazorpayOrderId || !finalRazorpayPaymentId || !finalRazorpaySignature) {
      setError(
        "submission",
        "Payment information is incomplete. Please complete the payment first."
      );
      setIsSubmitting(false);
      return;
    }

    // Pre-submission hexagon conflict check
    const allSubcategories = currentService?.subcategories ?? [];
    const selectedHexagons = coverageAreas.selectedHexagons ?? [];

    if (allSubcategories.length > 0 && selectedHexagons.length > 0) {
      const conflictResult = await checkHexConflicts(
        allSubcategories,
        selectedHexagons,
        currentService?.category,
        submittedFormId
      );
      if (conflictResult.unavailableHexagons?.length > 0) {
        setError(
          "submission",
          "Some selected areas are already taken by another partner in your category. Please go back and choose different areas on the map."
        );
        setIsSubmitting(false);
        return;
      }
    }

    // Upload documents if any
    let documentUrls: string[] = [];
    if (documents.length > 0) {
      documentUrls = await uploadDocuments(documents);
      setUploadedDocumentUrls(documentUrls);
    }

    // Prepare service details in the format expected by backend
    const formattedServiceDetails = {
      services: {
        category: currentService.category,
        subcategories: currentService.subcategories,
        serviceChargeCategory: currentService.serviceChargeCategory,
      }
    };

    const isCustom = selectedPlan?.type === 'custom' || selectedPlan?.name?.toLowerCase().includes('custom');
    const customCostPerHex = selectedPlan?.costPerHex ?? selectedPlan?.pricing?.costPerHex ?? 0;
    const customHexCount = coverageAreas.selectedHexagons.length;
    const calculatedBase = isCustom
      ? customHexCount * customCostPerHex
      : selectedPlan?.pricing?.sellingPrice ?? selectedPlan?.pricing?.finalPrice ?? 0;

    // Prepare coverage areas data with plan ID and all required fields
    const coverageData = {
      selectedPlan: selectedPlan ? {
        planId: selectedPlan.id || selectedPlan._id,
        planName: selectedPlan.name,
        type: isCustom ? 'custom' : selectedPlan.type,
        costPerHex: customCostPerHex,
        hexCount: isCustom ? customHexCount : (selectedPlan.features?.hexCount ?? 0),
        pricePerYear: calculatedBase,
        sellingPrice: calculatedBase,
        isAllKerala: !isCustom && selectedPlan.features?.hexCount === 0,
        isTrial: selectedPlan.isTrial === "yes" ? "yes" : "no",
        trialDays: selectedPlan.trialDays || 0,
        maxUsersAllowed: selectedPlan.availability?.totalSlots || 0,
      } : null,
      selectedHexagons: coverageAreas.selectedHexagons,
    };

    // Prepare branch details - ensure it's not null
    const branchData: BranchDetails = branchDetails ? {
      branchName: branchDetails.branchName,
      branchType: branchDetails.branchType,
      contactPerson: branchDetails.contactPerson,
      phoneNumbers: branchDetails.phoneNumbers || [basicInfo.mobileNumber],
      emailAddresses: branchDetails.emailAddresses || [],
      location: branchDetails.location,
      operatingHours: branchDetails.operatingHours || [],
      nearbyHexagons: branchDetails.nearbyHexagons || coverageAreas.selectedHexagons,
    } : {
      // Provide default branch details if none exists (should not happen as branch step is required)
      branchName: basicInfo.businessName || "Main Branch",
      branchType: "main",
      phoneNumbers: [basicInfo.mobileNumber],
      emailAddresses: [],
      location: {
        type: "Point",
        coordinates: [76.2673, 9.9312], // Default Kochi coordinates
      },
      operatingHours: [],
      nearbyHexagons: coverageAreas.selectedHexagons,
    };

    // Prepare form data with guaranteed string values
    const formData = {
      basicInfo,
      serviceDetails: formattedServiceDetails,
      coverageAreas: coverageData,
      branchDetails: branchData,
      additionalInfo,
      listingDetails,
      payment: {
        razorpayOrderId: finalRazorpayOrderId,
        razorpayPaymentId: finalRazorpayPaymentId,
        razorpaySignature: finalRazorpaySignature,
        amount: finalAmount,
        currency: finalCurrency,
      },
      documents: documentUrls,
      termsAccepted: true,
    };

    const sanitizePayload = (obj: any): any => {
      if (obj === null || obj === undefined) return obj;
      if (Array.isArray(obj)) {
        return obj.map(sanitizePayload);
      }
      if (typeof obj === "object") {
        const newObj: any = {};
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const val = obj[key];
            if (typeof val === "string" && val.trim() === "") {
              if (["whatsappNumber", "gstNumber", "employeeCode", "currency"].includes(key)) {
                newObj[key] = "";
              } else {
                newObj[key] = undefined;
              }
            } else {
              newObj[key] = sanitizePayload(val);
            }
          }
        }
        return newObj;
      }
      return obj;
    };

    const sanitizedFormData = sanitizePayload(formData);
    const result = await submitPartnerForm(sanitizedFormData);
    setSubmittedFormId(result._id || result.id);
  } catch (error: any) {
    console.error("Error submitting form:", error);
    const errorMessage =
      error.errors && error.errors.length > 0
        ? error.errors.join(", ")
        : error.message || "Failed to submit form. Please try again.";
    setError("submission", errorMessage);
  } finally {
    setIsSubmitting(false);
  }
};

  // Trial plan view
  if (isTrial) {
    const cgstAmount = trialCgst;
    const sgstAmount = trialSgst;
    const totalAmount = Math.round(trialFinalAmount);
    
    return (
      <div className="space-y-5 md:space-y-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
            Complete Registration
          </h2>
          <p className="text-sm md:text-base text-secondary-600">
            Review and complete your trial registration
          </p>
        </div>

        {/* Branch Summary */}
        {branchDetails && (
          <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
            <h3 className="font-medium text-blue-800 mb-2">Branch Information</h3>
            <p className="text-sm text-blue-700">
              <strong>{branchDetails.branchName}</strong>{branchDetails.branchType ? ` (${branchDetails.branchType.replace('_', ' ')})` : ''}
            </p>
            {branchDetails.location?.address && (
              <p className="text-xs text-blue-600 mt-1">{branchDetails.location.address}</p>
            )}
          </div>
        )}

        {/* Trial Info Section */}
        <div className="p-5 md:p-6 bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl border-2 border-amber-300">
          <div className="flex items-center gap-3 mb-4">
            <div>
              <p className="text-lg font-bold text-amber-800">
                {selectedPlan?.displayName} {isTrial ? "Trial " : ""}Plan
              </p>
              {isTrial && selectedPlan?.trialDays > 0 && (
                <p className="text-xs text-amber-600 mt-1">
                  {selectedPlan.trialDays} days trial period
                </p>
              )}
              {(pricing?.payAfterSales ?? 0) > 0 && (
                <p className="text-xs font-medium text-amber-700 mt-1">
                  Pay ₹{(pricing?.payAfterSales ?? 0).toLocaleString()} (ex. GST) After First Sale
                </p>
              )}
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-amber-700">Trial Price:</span>
              <span className="font-bold text-green-700 text-lg">
                ₹{Math.round(trialSellingPrice).toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between pl-4">
              <span className="text-amber-700 text-sm">CGST (9%):</span>
              <span className="font-medium text-amber-700">
                ₹{cgstAmount.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between pl-4">
              <span className="text-amber-700 text-sm">SGST (9%):</span>
              <span className="font-medium text-amber-700">
                ₹{sgstAmount.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between pt-2 border-t border-amber-200">
              <span className="text-amber-700">Total Trial Amount:</span>
              <span className="font-bold text-green-700 text-xl">
                ₹{totalAmount.toLocaleString()}
              </span>
            </div>
            <p className="text-xs text-amber-600 text-right mt-1">
              (Inclusive of CGST & SGST)
            </p>
          </div>
        </div>

        {/* Terms & Conditions Agreement Checkbox */}
        <div className="p-4 bg-white rounded-lg border border-secondary-200">
          <div className="flex items-start space-x-2.5">
            <input
              id="trialTermsAccepted"
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => {
                setTermsAccepted(e.target.checked);
                if (e.target.checked && errors.submission) {
                  setError("submission", "");
                }
              }}
              className="mt-0.5 h-4 w-4 rounded border-secondary-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
            />
            <label htmlFor="trialTermsAccepted" className="text-xs md:text-sm text-secondary-700 leading-snug cursor-pointer select-none">
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-primary-600 font-medium hover:underline">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/refund-policy" target="_blank" rel="noopener noreferrer" className="text-primary-600 font-medium hover:underline">
                Refund Policy
              </a>
              .
            </label>
          </div>
        </div>

        {errors.submission && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm md:text-base text-red-600">
              {errors.submission as string}
            </p>
          </div>
        )}

        <NavigationButtons
          onPrevious={previousStep}
          onNext={!paymentInitiated ? handleCreatePaymentOrder : handleSubmitForm}
          nextLabel={!paymentInitiated ? `Pay ₹${totalAmount.toLocaleString()} & Register` : "Complete Registration"}
          nextDisabled={isCreatingOrder || isSubmitting || !termsAccepted}
        />
      </div>
    );
  }

  const regularPayInitially = selectedPlan?.pricing?.payInitially ?? 0;
  const baseAmount = regularPayInitially > 0 ? regularPayInitially : (selectedPlan?.pricing?.sellingPrice || listingDetails.listingAmount);
  
  const cgstAmount = Math.round(baseAmount * 0.09);
  const sgstAmount = Math.round(baseAmount * 0.09);
  const totalAmount = baseAmount + cgstAmount + sgstAmount;

  return (
    <div className="space-y-5 md:space-y-6">
      <div>
        <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
          Payment & Completion
        </h2>
        <p className="text-sm md:text-base text-secondary-600">
          Complete payment to finalize your registration
        </p>
      </div>

      {/* Branch Summary */}
      {branchDetails && (
        <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h3 className="font-medium text-blue-800 mb-2">Branch Information</h3>
          <p className="text-sm text-blue-700">
            <strong>{branchDetails.branchName}</strong>{branchDetails.branchType ? ` (${branchDetails.branchType.replace('_', ' ')})` : ''}
          </p>
          {branchDetails.location?.address && (
            <p className="text-xs text-blue-600 mt-1">{branchDetails.location.address}</p>
          )}
          {branchDetails.nearbyHexagons && branchDetails.nearbyHexagons.length > 0 && (
            <p className="text-xs text-blue-600 mt-1">
              Coverage: {branchDetails.nearbyHexagons.length} hexagons around branch
            </p>
          )}
        </div>
      )}

      {/* Payment Section */}
      <div className="space-y-4">
        <div className="p-5 md:p-6 bg-gradient-to-br from-primary-50 to-secondary-50 rounded-xl border-2 border-primary-200">
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <p className="text-sm font-medium text-secondary-700">Plan Amount:</p>
              <p className="text-lg font-bold text-secondary-900">₹{Math.round(baseAmount).toLocaleString()}</p>
            </div>
            <div className="flex justify-between items-center pl-4">
              <p className="text-xs text-secondary-600">CGST (9%):</p>
              <p className="text-sm text-secondary-700">+₹{cgstAmount.toLocaleString()}</p>
            </div>
            <div className="flex justify-between items-center pl-4">
              <p className="text-xs text-secondary-600">SGST (9%):</p>
              <p className="text-sm text-secondary-700">+₹{sgstAmount.toLocaleString()}</p>
            </div>
            <div className="pt-2 border-t border-primary-200">
              <div className="flex justify-between items-center">
                <p className="text-sm font-semibold text-secondary-900">Total Amount:</p>
                <p className="text-3xl md:text-4xl font-bold text-primary-600">
                  ₹{totalAmount.toLocaleString()}
                </p>
              </div>
              <p className="text-xs text-secondary-500 text-right mt-1">
                (Inclusive of CGST & SGST)
              </p>
            </div>
            {selectedPlan && (
              <p className="text-xs text-secondary-500 mt-2">
                {selectedPlan.displayName} Plan • {coverageAreas.selectedHexagons.length} hexagons •
                ~{(coverageAreas.selectedHexagons.length * 5.16).toFixed(0)} km²
              </p>
            )}
          </div>
        </div>

        {/* Terms & Conditions Agreement Checkbox */}
        <div className="p-4 bg-white rounded-lg border border-secondary-200">
          <div className="flex items-start space-x-2.5">
            <input
              id="regularTermsAccepted"
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => {
                setTermsAccepted(e.target.checked);
                if (e.target.checked && errors.submission) {
                  setError("submission", "");
                }
              }}
              className="mt-0.5 h-4 w-4 rounded border-secondary-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
            />
            <label htmlFor="regularTermsAccepted" className="text-xs md:text-sm text-secondary-700 leading-snug cursor-pointer select-none">
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-primary-600 font-medium hover:underline">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/refund-policy" target="_blank" rel="noopener noreferrer" className="text-primary-600 font-medium hover:underline">
                Refund Policy
              </a>
              .
            </label>
          </div>
        </div>

        {!paymentInitiated ? (
          <Button
            onClick={handleCreatePaymentOrder}
            size="lg"
            fullWidth
            isLoading={isCreatingOrder}
            disabled={!termsAccepted}
            className="min-h-[56px] md:min-h-[48px]"
          >
            Pay ₹{totalAmount.toLocaleString()} & Complete Registration
          </Button>
        ) : (
          <div className="text-center p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm md:text-base text-blue-700">
              Payment window opened. Please complete the payment.
            </p>
          </div>
        )}
      </div>

      {errors.payment && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm md:text-base text-red-600">
            {errors.payment as string}
          </p>
        </div>
      )}

      {errors.submission && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm md:text-base text-red-600">
            {errors.submission as string}
          </p>
        </div>
      )}

      <NavigationButtons
        onPrevious={previousStep}
        onNext={() => { }}
        showNext={false}
        previousDisabled={paymentInitiated}
      />
    </div>
  );
};

export default PartnerFormStep6;